<script setup lang="ts">
import { MenuItems, MenuItem } from '@headlessui/vue'
import { useCurrentPageResource } from '~/composables/useCurrentPageResource'

const { open, openDirection = 'up' } = defineProps<{
  open: boolean
  openDirection?: 'up' | 'down'
}>()

const emit = defineEmits<{
  localeSelected: []
}>()

const { locale, t } = useI18n()
const { data: resource } = await useCurrentPageResource()
const { availableLocales, shouldShowLanguagePicker, getLocaleUrl } =
  useLocaleSwitcher(resource)

const getShortLocaleLabel = (localeCode: string): string => {
  const translationKey = `general.languages.shortCodes.${localeCode}` as any
  return t(translationKey) || localeCode.toUpperCase()
}

const handleLocaleClick = (close: () => void) => {
  close()
  emit('localeSelected')
}
</script>

<template>
  <MenuItems
    static
    :class="[
      'absolute left-0 flex flex-col bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden z-10 min-w-[80px]',
      openDirection === 'up' ? 'bottom-full mb-2' : 'top-full mt-2',
      open && shouldShowLanguagePicker ? '' : 'invisible',
    ]"
  >
    <MenuItem
      v-for="loc in availableLocales"
      :key="loc.code"
      v-slot="{ active, close }"
    >
      <NuxtLink
        external
        :class="[
          'px-4 py-2 text-sm text-gray-800 hover:bg-gray-50 w-full text-left',
          active ? 'bg-gray-50' : '',
          locale === loc.code ? 'font-semibold' : '',
        ]"
        :to="getLocaleUrl(loc.code)"
        @click="handleLocaleClick(close)"
      >
        {{ getShortLocaleLabel(loc.code) }}
      </NuxtLink>
    </MenuItem>
  </MenuItems>
</template>
